/* MCR reels · Universe layout (<mcr-universe>): one active "moment" drives the centre player,
   the product card, the chapter tabs and the tilted reel cards. Posters-only reels advance on a story
   timer; reels with video play muted and advance when the video ends. Paused off-screen and on
   reduced motion. Add to bag uses AJAX + the cart drawer when present, else the plain form post. */
(function () {
  if (customElements.get('mcr-universe')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function clock(s) { s = Math.max(0, Math.round(s || 0)); return pad(Math.floor(s / 60)) + ':' + pad(s % 60); }

  class McrUniverse extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.slides = [].slice.call(this.querySelectorAll('[data-slide]'));
      this.n = this.slides.length;
      if (!this.n) return;
      this.cards = [].slice.call(this.querySelectorAll('[data-card]'));
      this.pcards = [].slice.call(this.querySelectorAll('[data-pcard]'));
      this.chapters = [].slice.call(this.querySelectorAll('.mcr-uni__chapter'));
      this.bar = this.querySelector('[data-progress]');
      this.timeEl = this.querySelector('[data-time]');
      this.nowEl = this.querySelector('[data-now]');
      this.toggleBtn = this.querySelector('[data-toggle]');
      this.muteBtn = this.querySelector('[data-mute]');
      this.storyMs = parseInt(this.dataset.storyMs, 10) || 6000;
      this.maxMs = parseInt(this.dataset.maxMs, 10) || 25000;
      this.autoplay = this.dataset.autoplay !== 'false' && !reduce.matches;
      this.index = 0;
      this.userPaused = !this.autoplay;
      this.inView = false;
      this.muted = true;
      this.elapsed = 0;

      var self = this;
      this.addEventListener('click', function (e) {
        var go = e.target.closest('[data-go]');
        if (go) { self.go(parseInt(go.getAttribute('data-go'), 10), true); return; }
        if (e.target.closest('[data-toggle]')) { self.userPaused = !self.userPaused; self.sync(); return; }
        if (e.target.closest('[data-mute]')) { self.muted = !self.muted; self.applyMute(); }
      });
      this.addEventListener('keydown', function (e) {
        var tab = e.target.closest('.mcr-uni__chapter');
        if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
        e.preventDefault();
        var i = (self.index + (e.key === 'ArrowRight' ? 1 : -1) + self.n) % self.n;
        self.go(i, true);
        self.chapters[i] && self.chapters[i].focus();
      });
      this.querySelectorAll('[data-uni-form]').forEach(function (f) {
        f.addEventListener('submit', function (e) { self.add(e, f); });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          self.inView = entries[0].isIntersecting;
          self.sync();
        }, { threshold: 0.35 }).observe(this.querySelector('[data-player]'));
      }
      document.addEventListener('visibilitychange', function () { self.sync(); });
      // Entrance: the gold thread draws in, then the preview frames settle one at a time (CSS, once).
      if ('IntersectionObserver' in window && !reduce.matches) {
        this.classList.add('is-pre');
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          self.classList.add('is-in');
          io.disconnect();
          setTimeout(function () { self.classList.add('is-settled'); }, 3200);
        }, { threshold: 0.2 });
        io.observe(this.querySelector('.mcr-uni__stage'));
      }
      this.go(0, false);
    }

    playing() { return !this.userPaused && this.inView && !document.hidden; }

    video() { var s = this.slides[this.index]; return s && s.querySelector('video'); }

    go(i, user) {
      if (isNaN(i)) return;
      var prevVideo = this.video();
      if (prevVideo) { prevVideo.pause(); }
      this.index = (i + this.n) % this.n;
      var self = this;
      this.slides.forEach(function (s, k) { var on = k === self.index; s.hidden = !on; s.classList.toggle('is-active', on); });
      this.pcards.forEach(function (p, k) { p.hidden = k !== self.index; });
      this.chapters.forEach(function (c, k) {
        var on = k === self.index;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
      var slots = ['a', 'b', 'c'];
      this.cards.forEach(function (c) { c.setAttribute('data-slot', 'off'); });
      for (var k = 1; k < Math.min(this.n, 4); k++) {
        var card = this.cards[(this.index + k) % this.n];
        if (card) card.setAttribute('data-slot', slots[k - 1]);
      }
      if (this.nowEl) this.nowEl.textContent = pad(this.index + 1);
      var rn = this.querySelector('[data-now-rail]');
      if (rn) rn.textContent = pad(this.index + 1);
      var rc = this.querySelector('[data-cap-rail]');
      var cardNow = this.cards[this.index];
      if (rc && cardNow) rc.textContent = cardNow.getAttribute('data-caption') || '';
      this.elapsed = 0;
      this.last = 0;
      if (user && this.userPaused && this.autoplay) this.userPaused = false;
      var v = this.video();
      if (v && !v.src && v.dataset.src) { v.src = v.dataset.src; v.preload = 'metadata'; }
      if (this.muteBtn) this.muteBtn.hidden = !v;
      if (v) {
        v.currentTime = 0;
        v.onended = function () { self.go(self.index + 1, false); };
      }
      this.applyMute();
      this.sync();
    }

    applyMute() {
      var v = this.video();
      if (v) v.muted = this.muted;
      if (this.muteBtn) this.muteBtn.setAttribute('aria-pressed', this.muted ? 'false' : 'true');
      this.classList.toggle('is-sound', !this.muted);
    }

    sync() {
      var on = this.playing();
      this.classList.toggle('is-paused', !on);
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-label', this.toggleBtn.getAttribute(this.userPaused ? 'data-label-play' : 'data-label-pause'));
      var v = this.video();
      if (v) {
        if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      }
      if (on && !this.raf) { this.last = 0; this.raf = requestAnimationFrame(this.tick.bind(this)); }
      if (!on && this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; }
      this.paint();
    }

    tick(t) {
      this.raf = 0;
      if (!this.playing()) return;
      var v = this.video();
      if (!v) {
        if (this.last) this.elapsed += t - this.last;
        this.last = t;
        if (this.elapsed >= this.storyMs) { this.go(this.index + 1, false); return; }
      } else if (v.currentTime * 1000 >= this.maxMs) {
        this.go(this.index + 1, false);
        return;
      }
      this.paint();
      this.raf = requestAnimationFrame(this.tick.bind(this));
    }

    paint() {
      var v = this.video();
      var cur, dur;
      if (v && v.duration) { cur = v.currentTime; dur = Math.min(v.duration, this.maxMs / 1000); }
      else { cur = this.elapsed / 1000; dur = this.storyMs / 1000; }
      if (this.bar) this.bar.style.transform = 'scaleX(' + Math.min(1, dur ? cur / dur : 0) + ')';
      if (this.timeEl) this.timeEl.textContent = clock(cur) + ' / ' + clock(dur);
    }

    add(e, form) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('.mcr-uni__add');
      var data = new FormData(form);
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: +data.get('id'), quantity: 1 }] };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      btn.disabled = true;
      btn.classList.add('is-loading');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          if (drawer && drawer.renderContents) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          if (window.MCR && window.MCR.toast) window.MCR.toast(err.message || 'Error');
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    }
  }
  customElements.define('mcr-universe', McrUniverse);
})();
